import React from 'react';
import { trackDownload } from 'utils/general';
import ShareContent from 'components/common/modals/ShareContent';

class ToolsNav extends React.Component {
  constructor(props) {
    super(props);

    // Bindings
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const type = e.currentTarget.getAttribute('data-type') || '';
    switch (type) {
      case 'share': this.props.setModalContent(<ShareContent />); break;
      case 'download': {
        if (this.props.isPrint) {
          window.print();
          ga('send', 'event', 'PDF', 'Print', 'Country profile', 1);
        } else if (this.props.onDownload) {
          trackDownload({ currentTarget: { href: 'nrgi_data.csv?' } });
          this.props.onDownload();
        }
        break;
      }
      default: false;
    }
  }

  render() {
    return (
      <div className="row">
        <div className="column small-12">
          <div className="c-tools-bar">
            <ul>
              <li>
                <button data-type="share" onClick={this.handleClick}>
                  <svg className="c-icon -small -light icon-share"><use xlinkHref="#icon-share"></use></svg>
                  Share
                </button>
              </li>
              {this.props.hasDownload &&
                <li>
                  <button data-type="download" onClick={this.handleClick}>
                    <svg className="c-icon -small -light icon-download"><use xlinkHref="#icon-download"></use></svg>
                    {this.props.downloadText || 'Download'}
                  </button>
                </li>
              }
            </ul>
          </div>
        </div>

      </div>
    );
  }
}

ToolsNav.propTypes = {
  hasDownload: React.PropTypes.bool,
  isPrint: React.PropTypes.bool,
  downloadText: React.PropTypes.string,
  // Actions
  setModalContent: React.PropTypes.func,
  onDownload: React.PropTypes.func,
  handleYearsChange: React.PropTypes.func
};

ToolsNav.defaultProps = {
  hasDownload: true
};

export default ToolsNav;



// WEBPACK FOOTER //
// ./app/components/common/ToolsBar.jsx